import { MdDashboard, MdOutlineManageAccounts, MdPassword } from 'react-icons/md';
import { BiSpreadsheet } from 'react-icons/bi';
import { IRoutesLink, ISideBarRoutes } from "../../../Utils/interfaces";
import { CgProfile } from "react-icons/cg";


// DIGITIZER Routes

import Dashboard from "../Pages/Dashboard/Dashboard";
import AllOrder from "../Pages/AllOrders/AllOrder";
import OrderDetails from '../Pages/AllOrders/OrderDetails/OrderDetails';
import UploadAttachment from '../Pages/AllOrders/UploadAttachments/UploadAttachment';
import MyProfile from '../../Customer/Pages/MyProfile/MyProfile';
import ChangePassword from '../../Customer/Pages/MyProfile/ChangePassword/ChangePassword';

// Icons

import dashboardIcon from '../../../Assets/images/dashboard-nav-icon.png';
import AllOrdersIcon from '../../../Assets/images/digitizing-nav-icon-records.png';
import myAccountIcon from '../../../Assets/images/my-account-nav-icon.png';
import LockICon from '../../../Assets/images/lock-nav-icon.png';

// Digitizer Routes

export const digitizerRoutes: IRoutesLink[] = [
    {
        path: "/digitizer/dashboard",
        component: <Dashboard />,
    },

    {
        path: "/digitizer/orders",
        component: <AllOrder />,
    },

    {
        path: "/digitizer/profile",
        component: <MyProfile />,
    },

    {
        path: "/digitizer/reset-password",
        component: <ChangePassword />,
    },

    {
        path: "/digitizer/orders-details/:id",
        component: <OrderDetails />
    },

    {
        path: "/digitizer/attachment-upload/:id",
        component: <UploadAttachment />
    },
];

export const digitizerSideBarItems: ISideBarRoutes[] = [
    {
        path: "/digitizer/dashboard",
        icon: <img src={dashboardIcon} alt="dashboard" />,
        title: "Dashboard",
        isSubNav: false,
    },
    {
        path: "/digitizer/orders",
        icon: <img src={AllOrdersIcon} alt="dashboard" />,
        title: "All Orders",
        isSubNav: false,
    },

    {
        path: "",
        icon: <img src={myAccountIcon} alt="account" />,
        title: "My Account",
        isSubNav: true,
        subNav: [
            {
                path: "/digitizer/profile",
                component: <MyProfile />,
                icon: <img src={myAccountIcon} alt="profile" />,
                title: "My Profile"
            },
            {
                path: "/digitizer/reset-password",
                component: <ChangePassword />,
                icon: <img src={LockICon} alt="profile" />,
                title: "Change Password"
            },
        ]
    },

];